

export class AgingWiseReq {

    fromDate?:Date;
    toDate?:Date;
    unitId?:number
    unitName?:string
    supplierName?:string
    vendorName?:string
    constructor(
        fromDate?:Date,
        toDate?:Date,
        unitId?:number,
        unitName?:string,
        supplierName?:string,
        vendorName?:string
    ){
        this.fromDate= fromDate
        this.toDate = toDate
        this.unitId = unitId
        this.unitName = unitName
        this.supplierName = supplierName
        this.vendorName = vendorName
        
    }
}
